import enablePathInputs from './enablePathInputs';
import { formFieldValues } from '../../principles/selectors/formFieldValue';

export default function handleProductTypeNavigation(event) {
  const { form } = event.detail;
  if(formFieldValues(form, 'product-type').join().indexOf('1-on-1 tutoring') > -1) {
    event.detail.targetPanel = form.querySelector(
      '.lead-constructor__panel[data-id="who-needs-tutor"]'
    );
    enablePathInputs(form, 0);
  } else {
    enablePathInputs(form, 1);
  }
}
